import { KeyboardEvent } from 'react';

// Schede selezionabili dello Smart multi-store (role checkbox o radio): il clic e la
// tastiera sono gestiti dal contenitore, che ha il ruolo ARIA e resta lo stesso fra un
// render e l'altro, quindi tiene il focus. Il riquadro interno (MultiStoreCardFrame) serve
// solo alla resa.

// Invio e barra spaziatrice attivano la scheda come farebbe un controllo nativo
export const handleActivationKey = (
  event: KeyboardEvent<HTMLElement>,
  action: () => void
): void => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  action();
};

// Link della riga d'ingresso («Scegli i centri») o di riepilogo («Modifica») che apre il
// pannello dei centri. Le due righe non sono mai sulla pagina insieme, quindi l'id è unico.
export const MULTI_STORE_PANEL_TOGGLE_ID = 'multi-store-panel-toggle';

// Chiuso il pannello con «Annulla» o con la ricerca, il focus torna al link della riga invece
// di finire sul body. Si aspetta il frame successivo: «Cerca in N centri» dall'ingresso passa
// al calendario unificato e «Cerca solo in …» torna al classico, quindi il link da
// raggiungere è quello della riga nuova, che esiste solo a render concluso.
export const focusMultiStorePanelToggle = (): void => {
  window.requestAnimationFrame(() => {
    document.getElementById(MULTI_STORE_PANEL_TOGGLE_ID)?.focus();
  });
};
